module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "noind",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("You can’t run away from true love, Debbie. Just like you can’t run away from God or your country or your family. It’s a part of you, and you’re a part of it. That’s why you and me, aw heck, we’ve just gotta get married when we grow up. We’ll have a mess of kids together. We’ll get old and gray together. It’ll be really neat. You’ll see.")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—Badger Hayes to Debbie Dale in "), _c('i', [_vm._v("Badger Hayes, All-American Boy")]), _vm._v(", a film by Matthew Wax")])])])]), _c('a', {
    attrs: {
      "id": "start"
    }
  })]), _c('a', {
    attrs: {
      "id": "start"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01538f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-start.vue
// module id = 75
// module chunks = 0